import {
  PathLocationStrategy,
  APP_BASE_HREF,
  PlatformLocation
} from "@angular/common";
import { Optional, Inject, Injectable } from "@angular/core";
import { UrlSerializer } from "@angular/router";
import { CommonService } from "./common.service";

@Injectable()
export class PathPreserveQueryLocationStrategy extends PathLocationStrategy {
  private get search(): string {
    return this.platformLocation?.search ?? "";
  }
  constructor(
    private platformLocation: PlatformLocation,
    private urlSerializer: UrlSerializer,
    private commonService: CommonService,
    @Optional() @Inject(APP_BASE_HREF) _baseHref?: string
  ) {
    super(platformLocation, _baseHref);
  }

  override prepareExternalUrl(internal: string): string {
    // This appends trailing slash to links. It needs to happen on the server so links are formated correctly on first load for SEO purposes.
    const path = this.commonService.formatUrl(super.prepareExternalUrl(internal));
    const urlTree = this.urlSerializer.parse(path);

    // Client side code to preserve existing query parameters. 
    if (this.commonService.isPlatformBrowser()) {
      const existingURLSearchParams = new URLSearchParams(this.search);
      existingURLSearchParams.delete('returnUrl');

      let existingQueryParams = Object.fromEntries(
        existingURLSearchParams.entries()
      );
      existingQueryParams = this.commonService.removeBlackListedParams(existingQueryParams)

      const nextQueryParams = urlTree.queryParams;
      const queryParams = { ...existingQueryParams, ...nextQueryParams };

      urlTree.queryParams = this.commonService.sanitizeParams(queryParams);
    }

    return urlTree.toString();
  }
}
